import { render } from "./SuperAdminLayout.vue?vue&type=template&id=04f46bc7&scoped=true"
import script from "./SuperAdminLayout.vue?vue&type=script&lang=js"
export * from "./SuperAdminLayout.vue?vue&type=script&lang=js"

import "./SuperAdminLayout.vue?vue&type=style&index=0&id=04f46bc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f46bc7"]])

export default __exports__